import { Button } from "@mui/material";
import Grid from "@mui/material/Grid";

function Trex() {
     function playAudio(audioPath: string) {
        const audio = new Audio(audioPath);
        audio.play();
    }

    return (
        <Grid
        container
        spacing={2}
        style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center', marginTop: '10px' }}
      >
        <Grid style={{marginBottom: '4px' }}><Button onClick={() => playAudio('/audio/00-soundtrack-dino.mp3')} variant="outlined" className="Musicbtn">MUSICA</Button></Grid>
        <Grid style={{marginBottom: '4px' }}><Button onClick={() => playAudio('/audio/forest-wildlife.mp3')} variant="outlined" className="Musicbtn">FORESTA</Button></Grid>
        <Grid style={{marginBottom: '4px' }}><Button onClick={() => playAudio('/audio/trex.mp3')} variant="outlined" className="Musicbtn">T-REX</Button></Grid>
        <Grid style={{marginBottom: '4px' }}><Button onClick={() => playAudio('/audio/velociraptor.mp3')} variant="outlined" className="Musicbtn">VELOCIRAPTOR</Button></Grid>
        <Grid style={{marginBottom: '4px' }}><Button onClick={() => playAudio('/audio/stegosauro.mp3')} variant="outlined" className="Musicbtn">STEGOSAURO</Button></Grid>
      </Grid>
    );
}
export default Trex;